import React, { useState } from "react";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { Card, FormRow, grid2 } from "../onboarding/adminUi";
import { btn } from "../leads/PriorityBadge";

const NUMS = [
  ["protein_g_per_kg", "Proteínas (g/kg)", 0.1], ["fat_g_per_kg", "Grasas (g/kg)", 0.1],
  ["min_kcal_per_kg", "Alerta: kcal/kg mínimas", 1], ["min_carbs_g_per_kg", "Alerta: carbohidratos mínimos (g/kg)", 0.1],
  ["weight_min", "Peso mínimo esperable (kg)", 1], ["weight_max", "Peso máximo esperable (kg)", 1],
  ["height_min", "Estatura mínima (cm)", 1], ["height_max", "Estatura máxima (cm)", 1],
  ["weight_min_minor", "Peso mínimo menores (kg)", 1], ["height_min_minor", "Estatura mínima menores (cm)", 1],
];
const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 30);

const DayTypeRow = ({ d, i, onChange, onRemove }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 40px", gap: 8, alignItems: "center", marginBottom: 8 }} data-testid={`nutri-daytype-${i}`}>
    <input className="qv-input" value={d.label} onChange={(e) => onChange({ ...d, label: e.target.value })} style={{ textTransform: "none" }} data-testid={`nutri-daytype-label-${i}`} />
    <input className="qv-input" type="number" step="1" value={d.kcal_per_kg} onChange={(e) => onChange({ ...d, kcal_per_kg: e.target.value })} data-testid={`nutri-daytype-kcal-${i}`} />
    <button style={{ ...btn("transparent"), padding: 8 }} onClick={onRemove} title="Quitar" data-testid={`nutri-daytype-remove-${i}`}><Trash2 size={14} /></button>
  </div>
);

export const ConfigCard = ({ cfg, onSaved }) => {
  const [c, setC] = useState(cfg);
  const [newLabel, setNewLabel] = useState("");
  const setDt = (i, v) => setC({ ...c, day_types: c.day_types.map((x, j) => (j === i ? v : x)) });
  const add = () => {
    const key = slug(newLabel);
    if (key.length < 2 || c.day_types.some((d) => d.key === key)) return toast.error("Nombre no válido o repetido");
    setC({ ...c, day_types: [...c.day_types, { key, label: newLabel.trim(), kcal_per_kg: 40 }] }); setNewLabel("");
  };
  const save = async () => {
    try {
      const body = { ...Object.fromEntries(NUMS.map(([k]) => [k, Number(c[k])])), day_types: c.day_types.map((d) => ({ ...d, kcal_per_kg: Number(d.kcal_per_kg) })) };
      const { data } = await api.put("/admin/nutrition/config", body); setC(data); onSaved(data); toast.success("Configuración guardada");
    } catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <Card title="Configuración nutricional" testid="nutri-config-card" right={<button style={btn("#dc2626")} onClick={save} data-testid="nutri-config-save"><Save size={14} /> Guardar</button>}>
      {cfg.is_default && <div className="emp-note" style={{ marginBottom: 12 }} data-testid="nutri-config-default">Valores orientativos de partida: revísalos y guarda para fijarlos como tuyos.</div>}
      <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 10 }}>Calorías de referencia por tipo de día (kcal por kg de peso). La IA las usa como referencia para estimar el gasto de cada futbolista, pero nunca las modifica.</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 40px", gap: 8, fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: "#737373", marginBottom: 6 }}><span>Tipo de día</span><span>kcal / kg</span><span /></div>
      {c.day_types.map((d, i) => <DayTypeRow key={d.key} d={d} i={i} onChange={(v) => setDt(i, v)} onRemove={() => setC({ ...c, day_types: c.day_types.filter((_, j) => j !== i) })} />)}
      <div style={{ display: "flex", gap: 8, margin: "6px 0 18px" }}>
        <input className="qv-input" value={newLabel} onChange={(e) => setNewLabel(e.target.value)} placeholder="Nuevo tipo de día (ej. Día de doble sesión)" style={{ flex: 1, textTransform: "none" }} data-testid="nutri-daytype-new" />
        <button style={btn("transparent")} onClick={add} disabled={!newLabel.trim()} data-testid="nutri-daytype-add"><Plus size={14} /> Añadir</button>
      </div>
      <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 10 }}>Macronutrientes: proteínas y grasas por kg; los carbohidratos se calculan solos para completar las calorías de cada día.</div>
      <div style={grid2}>
        {NUMS.map(([k, l, step]) => (
          <FormRow key={k} label={l}><input className="qv-input" type="number" step={step} value={c[k]} onChange={(e) => setC({ ...c, [k]: e.target.value })} data-testid={`nutri-cfg-${k}`} /></FormRow>
        ))}
      </div>
    </Card>
  );
};
